<template>
    <form-field v-bind="fieldProps">
        <suggest-input
            v-bind="inputProps"
            :suggestions="suggestions"
            @change="changeAndGetSuggestions($event)"
            @select="selectSuggestion($event)"
            @emitEvent="emitEvent($event, ['change', 'select'])"
        ></suggest-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import debounce from 'lodash/debounce'
    import FormFieldMixin from 'mixins/FormFieldMixin'
    import FormPrefillingMixin from 'mixins/FormPrefillingMixin'
    import config from '../../config'

    export default {
        mixins: [FormFieldMixin, FormPrefillingMixin],

        props: {
            placeholder: { type: String, default: undefined },
            suggestionsCall: { type: Function, required: true },
            minQueryLength: { type: Number, default: 2 },
            isSuggested: { type: Boolean, default: false },
        },

        data() {
            return {
                suggestions: [],
            }
        },

        methods: {
            changeAndGetSuggestions(value) {
                this.change(value)
                this.getSuggestions(value)
            },

            getSuggestions: debounce(function (query) {
                if (!query || query.length < this.minQueryLength) {
                    this.suggestions = []
                    return
                }
                this.suggestionsCall(query).then((suggestions) => {
                    this.suggestions = suggestions
                })
            }, config.DEBOUNCE.DEFAULT),

            selectSuggestion(value) {
                this.emitEvent({
                    name: 'select',
                    payload: this.suggestions.find((suggestion) => suggestion.value === value),
                })
            },
        },
    }
</script>
